/** MI DOMINO — 📲 the app on the phone.
 *  - registers the service worker (offline shell, instant reloads; network-first
 *    so a deploy is never masked by the cache)
 *  - "Instalar app" entry in the account menu when the browser offers install
 *    (Android/desktop Chrome: beforeinstallprompt; iOS: a how-to toast)
 *  - "¡Te toca!" attention when the tab is in the background: title blink,
 *    vibration on phones, and a system notification if the player allowed it. */
import { NET } from '../state';
import { $ } from './dom';
import { LANG } from './i18n';
import { toast } from './toast';

let installEvt: any = null;
const BASE_TITLE = 'MI DOMINO — La Mesa Global';

const isIOS = (): boolean => /iphone|ipad|ipod/i.test(navigator.userAgent) && !(window as any).MSStream;
const standalone = (): boolean => window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone === true;

export function initPWA(): void {
  // 1. service worker (secure contexts only; localhost counts)
  if ('serviceWorker' in navigator && (location.protocol === 'https:' || location.hostname === 'localhost')) {
    window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => { /* optional */ }); });
  }

  // 2. install entry
  const btn = $('acct-install');
  const showBtn = (on: boolean) => { if (btn) btn.style.display = on ? '' : 'none'; };
  window.addEventListener('beforeinstallprompt', (e: any) => {
    e.preventDefault();
    installEvt = e;
    showBtn(!standalone());
  });
  window.addEventListener('appinstalled', () => { installEvt = null; showBtn(false); toast(LANG === 'en' ? '📲 MI DOMINO installed!' : '📲 ¡MI DOMINO instalado!'); });
  if (btn) {
    if (isIOS() && !standalone()) showBtn(true);
    btn.onclick = async () => {
      if (installEvt) {
        installEvt.prompt();
        try { await installEvt.userChoice; } catch { /* dismissed */ }
        installEvt = null;
        showBtn(false);
        return;
      }
      toast(LANG === 'en'
        ? '📲 Safari: tap Share ⬆️ → "Add to Home Screen"'
        : '📲 Safari: toca Compartir ⬆️ → "Añadir a pantalla de inicio"');
    };
  }

  // 3. restore the title when the player comes back
  document.addEventListener('visibilitychange', () => { if (!document.hidden) stopBlink(); });
  window.addEventListener('focus', stopBlink);

  // 4. ask for notifications once, on the first tap into online play (a user gesture)
  const sec = $('online-sec');
  if (sec) sec.addEventListener('click', askNotify, { once: true, capture: true });
}

let blinkT: any = null;
function stopBlink(): void {
  if (blinkT) { clearInterval(blinkT); blinkT = null; }
  document.title = BASE_TITLE;
}

function askNotify(): void {
  try {
    if (!('Notification' in window) || Notification.permission !== 'default') return;
    Notification.requestPermission().catch(() => { /* */ });
  } catch { /* */ }
}

/** It's your turn: make sure the player notices even if they switched apps. */
export function nudgeTurn(): void {
  const msg = LANG === 'en' ? '🔔 YOUR TURN!' : '🔔 ¡TE TOCA!';
  // haptic only at online tables (solo turns come every few seconds — that would buzz nonstop)
  try { if (NET.active && navigator.vibrate) navigator.vibrate([90, 50, 90]); } catch { /* */ }
  if (!document.hidden) return;
  stopBlink();
  let on = false;
  blinkT = setInterval(() => { on = !on; document.title = on ? `${msg} · MI DOMINO` : BASE_TITLE; }, 900);
  try {
    if ('Notification' in window && Notification.permission === 'granted') {
      const n = new Notification('MI DOMINO', { body: msg + (LANG === 'en' ? ' Your dominos are waiting.' : ' Tus fichas te esperan.'), icon: '/logo-192.png', tag: 'md-turn', silent: true } as any);
      n.onclick = () => { try { window.focus(); } catch { /* */ } n.close(); };
      setTimeout(() => { try { n.close(); } catch { /* */ } }, 15000);
    }
  } catch { /* notifications unsupported */ }
}
